import { render } from "./UserRequests.vue?vue&type=template&id=e93d2fe8"
import script from "./UserRequests.vue?vue&type=script&lang=js"
export * from "./UserRequests.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/ravanjeyhan-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__